import type {RichDocument} from 'typings/portaro.be.types';
import type {IOnInit} from 'angular';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type NewDocumentsDataService from '../../data-services/new-documents.data-service';

/**
 * @ngdoc component
 * @name jpNewsSlider this name should be kpNewDocuments
 * @module portaro.components.kp-new-documents
 *
 * @description
 * Component for showing newest documents, old name jpNewsSlider
 */
export default class KpNewDocumentsComponent {
    public static componentName = 'jpNewsSlider';

    public templateUrl = require('./kp-new-documents.tpl.ftl');

    public controller = KpNewDocumentsComponentController;
}

class KpNewDocumentsComponentController implements IOnInit {
    public newDocuments: RichDocument[];

    /*@ngInject*/
    protected constructor(private newDocumentsDataService: NewDocumentsDataService) {
    }

    @ngAsync()
    public async $onInit() {
        this.newDocuments = await this.newDocumentsDataService.query();
    }
}
